import React from 'react';
import AppIcon from '../ui/AppIcon';

const SubscriptionPage = () => {
  return (
    <div className="container">
      <div className="text-center mt-5">
        <AppIcon size={60} />
        <h1>Subscription Plans</h1>
        <p>Choose your mindfulness journey</p>
        <p>Subscription page coming soon...</p>
      </div>
    </div>
  );
};

export default SubscriptionPage;
